import styled from "styled-components";
interface IContainerScrollCommon {
  height?: string;
  boxShadow?: string;
}
export const ContainerScrollCommon = styled.div<IContainerScrollCommon>`
  ${(props) => `
  .scroll {
    height: ${props.height ? props.height : "auto"};
    overflow: auto;
    width: auto;
  }
  .scroll::-webkit-scrollbar {
    width: 3px;
  }
  .scroll::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 6px ${props.boxShadow ? props.boxShadow : "#76bc21"};
  }
  `}
`;

interface IContainerScrollBank {
  height?: string;
}
export const ContainerScrollBank = styled.div<IContainerScrollBank>`
  ${(props) => `
  .scroll {
    height: ${props.height ? props.height : "auto"};
    overflow: auto;
    width: auto;
  }
  `}
  .scroll::-webkit-scrollbar {
    width: 3px;
  }
  .scroll::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 6px #76bc21;
  }
`;

interface IContainerConfigurateCommon {
  width?: string;
  minHeight?: string;
  maxHeight?: string;
}
export const ContainerConfigurateCommon = styled.div<IContainerConfigurateCommon>`
  ${(props) => `
    width: ${props.width ? props.width : "100%"};
    min-height: ${props.minHeight ? props.minHeight : "0vh"};
    max-height: ${props.maxHeight ? props.maxHeight : "100vh"};
  `}
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

interface IContainerGridColumnsTableCommon {
  padding?: string;
  marginTop?: string;
  gridTemplateColumns?: string;
}
export const ContainerGridColumnsTableCommon = styled.div<IContainerGridColumnsTableCommon>`
  ${(props) => `
    font-family: ${props.theme.fontFamilies.primaryFont};
    padding:${props.padding ? props.padding : "1.5rem 0rem"};;
    margin-top: ${props.marginTop ? props.marginTop : "1rem"};;
  `}
  box-sizing: border-box;
  width: 100%;
  .attribute {
    margin: 0 !important;
  }
  .item-container {
    align-items: center;
    display: grid;
    grid-template-columns: ${(props) => props.gridTemplateColumns};
  }
  .titles {
    display: none;
  }
  @media (max-width: 750px) {
    & > div:first-of-type {
      display: none;
    }
    .titles {
      ${(props) => `
      color: ${props.color ? props.color : props.theme.colors.gray};
      font-family: ${props.theme.fontFamilies.primaryFont};
    `}
      display: block;
      font-size: 1.2rem;
      font-weight: 700;
      justify-self: start;
      padding-left: 1rem;
    }

    .item-container {
      grid-template-columns: 1fr;
      row-gap: 0.5rem;
    }
    .attribute {
      align-items: center !important;
      column-gap: 0.5rem;
      display: grid !important;
      padding: 0.2rem 0;
      grid-template-columns: minmax(9em, 30%) 1fr;
      justify-items: center;
      & > :not(.titles) {
        align-items: center;
        margin-left: 0;
        margin-right: 0;
        text-align: center;
        & > p {
          align-self: center;
        }
      }
    }
  }
`;

export const TableHeaderCommonResponsive = styled.div`
  ${(props) => `
    color: ${props.theme.colors.gray};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 1rem;
  div {
    align-items: center;
    display: flex;
    flex-direction: column;
  }
  .main-info-header {
    align-items: flex-start;
  }
`;

interface IBodyContainerTableCommon {
  backgroundColor?: string;
  height?: string;
  marginBottom?: string;
  padding?: string;
}
export const BodyContainerTableCommon = styled.div<IBodyContainerTableCommon>`
  ${(props) => `
    background-color: ${
      props.backgroundColor ? props.backgroundColor : "#FFFFFF"
    };
    color: ${props.color ? props.color : "#000000"};
    font-family: ${props.theme.fontFamilies.primaryFont};
    height: ${props.height ? props.height : "0rem"};
    margin-bottom: ${props.marginBottom ? props.marginBottom : "0.8rem"};
    padding:${props.padding ? props.padding : "0.5rem 1.5rem"};
    @media (max-width: 750px) {
        height:auto;
    }
  `}
  border-radius: 1rem;
  display: grid;
  font-size: 1.4rem;
  font-weight: 500;

  div {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .main-info-header {
    align-items: flex-start;
  }
  .main-info-header p {
    margin: 0.5rem 0;
  }
  .id {
    color: ${(props) => (props.color ? props.color : "red")};
    font-size: 1.4rem;
    font-weight: 500;
  }
`;
interface IDivStatusCommon {
  status?: string;
}
export const DivStatusCommon = styled.div<IDivStatusCommon>`
  ${(props) => {
    const status = props.status.toLowerCase();
    let color, backgroundColor;
    if (status === "problem") {
      color = props.theme.colors.supportRed;
      backgroundColor =
        props.theme.colors.supportRed + props.theme.transparencies.p10;
    } else if (status === "warning") {
      color = props.theme.colors.blackTextBody;
      backgroundColor =
        props.theme.colors.supportYellow + props.theme.transparencies.p30;
    } else if (status === "ok") {
      color = props.theme.colors.betterGreen;
      backgroundColor =
        props.theme.colors.betterGreen + props.theme.transparencies.p10;
    } else if (status === "neutral") {
      color = props.theme.colors.gray;
      backgroundColor =
        props.theme.colors.gray72 + props.theme.transparencies.p20;
    } else if (status === "waiting") {
      color = props.theme.colors.stateBluebLack;
      backgroundColor = props.theme.colors.grayState;
    } else if (status === "serving") {
      color = props.theme.colors.blackTextBody;
      backgroundColor =
        props.theme.colors.gray72 + props.theme.transparencies.p20;
    } else if (status === "subneutral") {
      color = props.theme.colors.grayNoRequired;
      backgroundColor = props.theme.colors.white;
    } else {
      color = props.theme.colors.orangeText;
      backgroundColor =
        props.theme.colors.orangeText + props.theme.transparencies.p10;
    }
    return `
    .type-column-common {
      background-color: ${backgroundColor};
      color: ${color};
      font-size: 1.1rem;
      padding: 0.6rem;
      text-align: center;
    }`;
  }}

  align-items: center;
  display: flex;
  font-family: Montserrat;
  font-size: 1.1rem;
  height: 2.5rem;
  justify-content: center;
`;

export const ContainerBodyResponse = styled.div`
  @media (max-width: 750px) {
    height: auto;
    max-height: 85vh;
    overflow-y: scroll;
    overflow: auto;
    width: auto;

    ::-webkit-scrollbar {
      width: 3px;
    }
    ::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 6px #76bc21;
    }
  }
`;
